'use client'

import { ButtonArrow } from '@/components/ui/button-arrow'
import { useLingui } from '@lingui/react'
import { motion } from 'framer-motion'
import dynamic from 'next/dynamic'
import React, { useEffect } from 'react'
import AboutSection from './about-section'
import IndustrialTechnologySection from './industrial-technology'
import NewsEventSection from './news-event'
import ServicesSection from './services-solutions'
import VideoBanner from './video-banner'
import FeaturedProjectSection from './featured-project'

const Footer = dynamic(() => import('../../sections/footer'), { ssr: false })

export default function HomePage(): React.JSX.Element {
  const { i18n } = useLingui()

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [])

  return (
    <div className='h-full min-h-[calc(100vh-64px)] scrollbar-none scroll-smooth sm:overflow-y-auto sm:snap-y sm:snap-mandatory'>
      <div className='h-full overflow-hidden snap-start snap-always'>
        <VideoBanner
          videoSrc='/landing/home/videos/banner-video.mp4'
          fallbackImageSrc='/landing/home/fallback-banner.png'
          alt='Fallback banner'
          priority
        />
      </div>

      {/* Section 2: About Section */}
      <div className='md:min-h-screen snap-start snap-always'>
        <AboutSection />
      </div>

      {/* Section 3: Video Banner 2 */}
      <div className='snap-start snap-always max-sm:min-h-screen sm:h-screen'>
        <VideoBanner
          videoSrc='/landing/home/videos/banner-video-2.mp4'
          fallbackImageSrc='/landing/home/fallback-banner-2.png'
          alt='Fallback banner 2'
          className='max-sm:min-h-screen h-[calc(100vh-65px)] sm:h-screen relative'
        >
          <motion.div
            className='absolute left-1/2 top-1/2 w-[95vw] -translate-x-1/2 -translate-y-1/2 space-y-3 text-center font-light'
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h2 className='max-[376px]:text-[22px] text-2xl font-semibold sm:text-4xl lg:text-6xl'>
              {i18n._(`PIONE GROUP -  Real World AI & Blockchain Solutions`)}
            </h2>

            <ButtonArrow showSvg className='mt-3 font-normal'>
              {i18n._(`Discover more`)}
            </ButtonArrow>
          </motion.div>
        </VideoBanner>
      </div>

      {/* Section 4: Services Section */}
      <div className='snap-start snap-always'>
        <ServicesSection />
      </div>

      {/* Section 5: Featured Project */}
      <div className='snap-start snap-always'>
        <FeaturedProjectSection />
      </div>

      {/* Section 5: Industrial Technology Section */}
      <div className='snap-start snap-always'>
        <IndustrialTechnologySection />
      </div>

      {/* Section 6: Valuable Partnership Section */}
      {/* <div className='snap-start snap-always'>
        <ValuablePartnershipSection />
      </div> */}

      {/* Section 7: News Event Section */}
      <div className='snap-start snap-always'>
        <NewsEventSection />
      </div>

      {/* Section 8: Footer */}
      <div className='snap-start snap-always'>
        <Footer />
      </div>
    </div>
  )
}
